<template>
  <!-- 旧内核（不支持 :where 选择器，约 Chromium 88 以下）下 ant-design-vue 的样式整段失效，
       仅对这类浏览器提高样式优先级并转换逻辑属性；新浏览器保持默认，不影响现有样式覆盖 -->
  <a-style-provider v-bind="styleProviderProps">
    <a-config-provider
      :theme="{
        token: {
          colorPrimary: '#7273F7',
          colorError: '#D54941'
        }
      }"
      :locale="zhCN"
    >
      <router-view />
    </a-config-provider>
  </a-style-provider>
</template>

<script setup>
import {
  ConfigProvider as AConfigProvider,
  StyleProvider as AStyleProvider,
  legacyLogicalPropertiesTransformer
} from 'ant-design-vue'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import { debounce } from 'lodash'
import { setTwoToneColor } from '@ant-design/icons-vue'
import { useUploadStore } from '@/store/uploadStore'
import { onMounted, onUnmounted } from 'vue'
import { sessionCache, localCache } from '@/utils/cache'

/**
 * 当前浏览器是否支持 :where()。CSS.supports('selector()') 本身是 Chromium 83+ 的能力，
 * 更老的浏览器会返回 false 或抛错，一并按「不支持」处理。
 * @returns {boolean}
 */
const supportsWhereSelector = () => {
  try {
    return window.CSS?.supports?.('selector(:where(a))') === true
  } catch (error) {
    return false
  }
}
const styleProviderProps = supportsWhereSelector()
  ? {}
  : { hashPriority: 'high', transformers: [legacyLogicalPropertiesTransformer] }

// 初始化全局上传 store，确保路由切换期间实例常驻
useUploadStore()

dayjs.locale('zh-cn')
setTwoToneColor('#7273F7')

const _ResizeObserver = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 200)
    super(callback)
  }
}

const visibilityChangeEvent = () => {
  if (document.hidden) return
  console.log('用户离开了当前标签')
  const sessionTeam = sessionCache.getCache('teamInfo')
  const localTeam = localCache.getCache('teamMessage')

  // 缺少 team 信息时不刷新  避免在登录页/未初始化时误触发 reload
  if (!sessionTeam?.id || !localTeam?.id) {
    if (localTeam?.id) {
      sessionCache.setCache('teamInfo', localTeam)
    }
    return
  }

  if (sessionTeam.id !== localTeam.id) {
    location.reload()
    sessionCache.setCache('teamInfo', localTeam)
  }
}
const handleVisibilityChange = (type) => {
  if (type == 'add') {
    document.addEventListener('visibilitychange', visibilityChangeEvent)
  } else {
    document.removeEventListener('visibilitychange', visibilityChangeEvent)
  }
}
handleVisibilityChange('add')
onMounted(() => {
  handleVisibilityChange('add')
})
onUnmounted(() => {
  handleVisibilityChange('delete')
})
</script>

<style lang="less">
#app {
  background: #fff;
  // background: linear-gradient(180deg, #ebedff -6%, #fcfcff 9%, #fcfcff 24%, #fcfcff 97%);
}
</style>
